import { API } from 'aws-amplify';
import * as types from './types';

export const getListings = (storeId) => ({
  type: types.GET_LISTINGS,
  payload: {
    promise: API.get("api", `etsy/stores/${storeId}/listings`)
  }
});

export const getListingDetails = (storeId, listingId) => ({
  type: types.GET_LISTING_DETAILS,
  payload: {
    promise: API.get("api", `etsy/stores/${storeId}/listings/${listingId}`),
    listingId
  }
});

export const deleteMapping = (mappinId, productId) => ({
  type: types.DELETE_LISTING_MAPPING,
  payload: {
    promise: API.del("api", `mappings/${mappinId}/products/${productId}`),
    productId
  }
});

export const saveMapping = (mappingId, productId, payload) => ({
  type: types.SAVE_LISTING_MAPPING,
  payload: {
    promise: API.post('api', `mappings/${mappingId}/products/${productId}`, { body: payload }),
    productId
  }
});

export const createMapping = (payload) => ({
  type: types.CREATE_MAPPING,
  payload: {
    promise: API.post('api', 'mappings', { body: payload }),
    productId: payload.productId
  }
});